import { jsx as T, jsxs as J } from "react/jsx-runtime";
import { useState as V, useMemo as W, useEffect as Z } from "react";
import { useTranslation as ee } from "../../hooks/useTranslation.js";
import { e as ae, c as Y, m as c, a as ie, b as te, d as j, g as K, S as ne, f as se } from "../../pagination-BeOG0tbT.js";
import "../Context/index.js";
import "../IconButton/index.js";
import "../ProductTable/TableRowGroup.js";
import { Spacer as le } from "../Spacer/index.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
import P from "./productcardcarousel.module.js";
function Q(S, e, $, d) {
  return S.params.createElements && Object.keys(d).forEach((u) => {
    if (!$[u] && $.auto === !0) {
      let p = ae(S.el, `.${d[u]}`)[0];
      p || (p = Y("div", d[u]), p.className = d[u], S.el.append(p)), $[u] = p, e[u] = p;
    }
  }), $;
}
function re(S) {
  let {
    swiper: e,
    extendParams: $,
    on: d,
    emit: u
  } = S;
  $({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function p(r) {
    let l;
    return r && typeof r == "string" && e.isElement && (l = e.el.querySelector(r) || e.hostEl.querySelector(r), l) ? l : (r && (typeof r == "string" && (l = [...document.querySelectorAll(r)]), e.params.uniqueNavElements && typeof r == "string" && l && l.length > 1 && e.el.querySelectorAll(r).length === 1 ? l = e.el.querySelector(r) : l && l.length === 1 && (l = l[0])), r && !l ? r : l);
  }
  function E(r, l) {
    const m = e.params.navigation;
    r = c(r), r.forEach((f) => {
      f && (f.classList[l ? "add" : "remove"](...m.disabledClass.split(" ")), f.tagName === "BUTTON" && (f.disabled = l), e.params.watchOverflow && e.enabled && f.classList[e.isLocked ? "add" : "remove"](m.lockClass));
    });
  }
  function y() {
    const {
      nextEl: r,
      prevEl: l
    } = e.navigation;
    if (e.params.loop) {
      E(l, !1), E(r, !1);
      return;
    }
    E(l, e.isBeginning && !e.params.rewind), E(r, e.isEnd && !e.params.rewind);
  }
  function N(r) {
    r.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), u("navigationPrev"));
  }
  function D(r) {
    r.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), u("navigationNext"));
  }
  function L() {
    const r = e.params.navigation;
    if (e.params.navigation = Q(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(r.nextEl || r.prevEl)) return;
    let l = p(r.nextEl), m = p(r.prevEl);
    Object.assign(e.navigation, {
      nextEl: l,
      prevEl: m
    }), l = c(l), m = c(m);
    const f = (a, i) => {
      a && a.addEventListener("click", i === "next" ? D : N), !e.enabled && a && a.classList.add(...r.lockClass.split(" "));
    };
    l.forEach((a) => f(a, "next")), m.forEach((a) => f(a, "prev"));
  }
  function b() {
    let {
      nextEl: r,
      prevEl: l
    } = e.navigation;
    r = c(r), l = c(l);
    const m = (f, a) => {
      f.removeEventListener("click", a === "next" ? D : N), f.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    r.forEach((f) => m(f, "next")), l.forEach((f) => m(f, "prev"));
  }
  d("init", () => {
    e.params.navigation.enabled === !1 ? k() : (L(), y());
  }), d("toEdge fromEdge lock unlock", () => {
    y();
  }), d("destroy", () => {
    b();
  }), d("enable disable", () => {
    let {
      nextEl: r,
      prevEl: l
    } = e.navigation;
    if (r = c(r), l = c(l), e.enabled) {
      y();
      return;
    }
    [...r, ...l].filter((m) => !!m).forEach((m) => m.classList.add(e.params.navigation.lockClass));
  }), d("click", (r, l) => {
    let {
      nextEl: m,
      prevEl: f
    } = e.navigation;
    m = c(m), f = c(f);
    const a = l.target;
    let i = f.includes(a) || m.includes(a);
    if (e.isElement && !i) {
      const s = l.path || l.composedPath && l.composedPath();
      s && (i = s.find((o) => m.includes(o) || f.includes(o)));
    }
    if (e.params.navigation.hideOnClick && !i) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === a || e.pagination.el.contains(a))) return;
      let s;
      m.length ? s = m[0].classList.contains(e.params.navigation.hiddenClass) : f.length && (s = f[0].classList.contains(e.params.navigation.hiddenClass)), u(s === !0 ? "navigationShow" : "navigationHide"), [...m, ...f].filter((o) => !!o).forEach((o) => o.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const x = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), L(), y();
  }, k = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), b();
  };
  Object.assign(e.navigation, {
    enable: x,
    disable: k,
    update: y,
    init: L,
    destroy: b
  });
}
function F(S) {
  return S === void 0 && (S = ""), `.${S.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function oe(S) {
  let {
    swiper: e,
    extendParams: $,
    on: d,
    emit: u
  } = S;
  const p = "swiper-pagination";
  $({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (a) => a,
      formatFractionTotal: (a) => a,
      bulletClass: `${p}-bullet`,
      bulletActiveClass: `${p}-bullet-active`,
      modifierClass: `${p}-`,
      currentClass: `${p}-current`,
      totalClass: `${p}-total`,
      hiddenClass: `${p}-hidden`,
      progressbarFillClass: `${p}-progressbar-fill`,
      progressbarOppositeClass: `${p}-progressbar-opposite`,
      clickableClass: `${p}-clickable`,
      lockClass: `${p}-lock`,
      horizontalClass: `${p}-horizontal`,
      verticalClass: `${p}-vertical`,
      paginationDisabledClass: `${p}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let E, y = 0;
  function N() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function D(a, i) {
    const {
      bulletActiveClass: s
    } = e.params.pagination;
    a && (a = a[`${i === "prev" ? "previous" : "next"}ElementSibling`], a && (a.classList.add(`${s}-${i}`), a = a[`${i === "prev" ? "previous" : "next"}ElementSibling`], a && a.classList.add(`${s}-${i}-${i}`)));
  }
  function L(a, i, s) {
    if (a = a % s, i = i % s, i === a + 1)
      return "next";
    if (i === a - 1)
      return "previous";
  }
  function b(a) {
    const i = a.target.closest(F(e.params.pagination.bulletClass));
    if (!i)
      return;
    a.preventDefault();
    const s = j(i) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === s) return;
      const o = L(e.realIndex, s, e.slides.length);
      o === "next" ? e.slideNext() : o === "previous" ? e.slidePrev() : e.slideToLoop(s);
    } else
      e.slideTo(s);
  }
  function x() {
    const a = e.rtl, i = e.params.pagination;
    if (N()) return;
    let s = e.pagination.el;
    s = c(s);
    let o, A;
    const O = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, G = e.params.loop ? Math.ceil(O / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (A = e.previousRealIndex || 0, o = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (o = e.snapIndex, A = e.previousSnapIndex) : (A = e.previousIndex || 0, o = e.activeIndex || 0), i.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const v = e.pagination.bullets;
      let I, M, R;
      if (i.dynamicBullets && (E = te(v[0], e.isHorizontal() ? "width" : "height"), s.forEach((h) => {
        h.style[e.isHorizontal() ? "width" : "height"] = `${E * (i.dynamicMainBullets + 4)}px`;
      }), i.dynamicMainBullets > 1 && A !== void 0 && (y += o - (A || 0), y > i.dynamicMainBullets - 1 ? y = i.dynamicMainBullets - 1 : y < 0 && (y = 0)), I = Math.max(o - y, 0), M = I + (Math.min(v.length, i.dynamicMainBullets) - 1), R = (M + I) / 2), v.forEach((h) => {
        const C = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((w) => `${i.bulletActiveClass}${w}`)].map((w) => typeof w == "string" && w.includes(" ") ? w.split(" ") : w).flat();
        h.classList.remove(...C);
      }), s.length > 1)
        v.forEach((h) => {
          const C = j(h);
          C === o ? h.classList.add(...i.bulletActiveClass.split(" ")) : e.isElement && h.setAttribute("part", "bullet"), i.dynamicBullets && (C >= I && C <= M && h.classList.add(...`${i.bulletActiveClass}-main`.split(" ")), C === I && D(h, "prev"), C === M && D(h, "next"));
        });
      else {
        const h = v[o];
        if (h && h.classList.add(...i.bulletActiveClass.split(" ")), e.isElement && v.forEach((C, w) => {
          C.setAttribute("part", w === o ? "bullet-active" : "bullet");
        }), i.dynamicBullets) {
          const C = v[I], w = v[M];
          for (let z = I; z <= M; z += 1)
            v[z] && v[z].classList.add(...`${i.bulletActiveClass}-main`.split(" "));
          D(C, "prev"), D(w, "next");
        }
      }
      if (i.dynamicBullets) {
        const h = Math.min(v.length, i.dynamicMainBullets + 4), C = (E * h - E) / 2 - R * E, w = a ? "right" : "left";
        v.forEach((z) => {
          z.style[e.isHorizontal() ? w : "top"] = `${C}px`;
        });
      }
    }
    s.forEach((v, I) => {
      if (i.type === "fraction" && (v.querySelectorAll(F(i.currentClass)).forEach((M) => {
        M.textContent = i.formatFractionCurrent(o + 1);
      }), v.querySelectorAll(F(i.totalClass)).forEach((M) => {
        M.textContent = i.formatFractionTotal(G);
      })), i.type === "progressbar") {
        let M;
        i.progressbarOpposite ? M = e.isHorizontal() ? "vertical" : "horizontal" : M = e.isHorizontal() ? "horizontal" : "vertical";
        const R = (o + 1) / G;
        let h = 1, C = 1;
        M === "horizontal" ? h = R : C = R, v.querySelectorAll(F(i.progressbarFillClass)).forEach((w) => {
          w.style.transform = `translate3d(0,0,0) scaleX(${h}) scaleY(${C})`, w.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      i.type === "custom" && i.renderCustom ? (v.innerHTML = i.renderCustom(e, o + 1, G), I === 0 && u("paginationRender", v)) : (I === 0 && u("paginationRender", v), u("paginationUpdate", v)), e.params.watchOverflow && e.enabled && v.classList[e.isLocked ? "add" : "remove"](i.lockClass);
    });
  }
  function k() {
    const a = e.params.pagination;
    if (N()) return;
    const i = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let s = e.pagination.el;
    s = c(s);
    let o = "";
    if (a.type === "bullets") {
      let A = e.params.loop ? Math.ceil(i / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && A > i && (A = i);
      for (let O = 0; O < A; O += 1)
        a.renderBullet ? o += a.renderBullet.call(e, O, a.bulletClass) : o += `<${a.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${a.bulletClass}"></${a.bulletElement}>`;
    }
    a.type === "fraction" && (a.renderFraction ? o = a.renderFraction.call(e, a.currentClass, a.totalClass) : o = `<span class="${a.currentClass}"></span> / <span class="${a.totalClass}"></span>`), a.type === "progressbar" && (a.renderProgressbar ? o = a.renderProgressbar.call(e, a.progressbarFillClass) : o = `<span class="${a.progressbarFillClass}"></span>`), e.pagination.bullets = [], s.forEach((A) => {
      a.type !== "custom" && (A.innerHTML = o || ""), a.type === "bullets" && e.pagination.bullets.push(...A.querySelectorAll(F(a.bulletClass)));
    }), a.type !== "custom" && u("paginationRender", s[0]);
  }
  function r() {
    e.params.pagination = Q(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const a = e.params.pagination;
    if (!a.el) return;
    let i;
    typeof a.el == "string" && e.isElement && (i = e.el.querySelector(a.el)), !i && typeof a.el == "string" && (i = [...document.querySelectorAll(a.el)]), i || (i = a.el), !(!i || i.length === 0) && (e.params.uniqueNavElements && typeof a.el == "string" && Array.isArray(i) && i.length > 1 && (i = [...e.el.querySelectorAll(a.el)], i.length > 1 && (i = i.find((s) => ie(s, ".swiper")[0] === e.el))), Array.isArray(i) && i.length === 1 && (i = i[0]), Object.assign(e.pagination, {
      el: i
    }), i = c(i), i.forEach((s) => {
      a.type === "bullets" && a.clickable && s.classList.add(...(a.clickableClass || "").split(" ")), s.classList.add(a.modifierClass + a.type), s.classList.add(e.isHorizontal() ? a.horizontalClass : a.verticalClass), a.type === "bullets" && a.dynamicBullets && (s.classList.add(`${a.modifierClass}${a.type}-dynamic`), y = 0, a.dynamicMainBullets < 1 && (a.dynamicMainBullets = 1)), a.type === "progressbar" && a.progressbarOpposite && s.classList.add(a.progressbarOppositeClass), a.clickable && s.addEventListener("click", b), e.enabled || s.classList.add(a.lockClass);
    }));
  }
  function l() {
    const a = e.params.pagination;
    if (N()) return;
    let i = e.pagination.el;
    i && (i = c(i), i.forEach((s) => {
      s.classList.remove(a.hiddenClass), s.classList.remove(a.modifierClass + a.type), s.classList.remove(e.isHorizontal() ? a.horizontalClass : a.verticalClass), a.clickable && (s.classList.remove(...(a.clickableClass || "").split(" ")), s.removeEventListener("click", b));
    })), e.pagination.bullets && e.pagination.bullets.forEach((s) => s.classList.remove(...a.bulletActiveClass.split(" ")));
  }
  d("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const a = e.params.pagination;
    let {
      el: i
    } = e.pagination;
    i = c(i), i.forEach((s) => {
      s.classList.remove(a.horizontalClass, a.verticalClass), s.classList.add(e.isHorizontal() ? a.horizontalClass : a.verticalClass);
    });
  }), d("init", () => {
    e.params.pagination.enabled === !1 ? f() : (r(), k(), x());
  }), d("activeIndexChange", () => {
    typeof e.snapIndex > "u" && x();
  }), d("snapIndexChange", () => {
    x();
  }), d("snapGridLengthChange", () => {
    k(), x();
  }), d("destroy", () => {
    l();
  }), d("enable disable", () => {
    let {
      el: a
    } = e.pagination;
    a && (a = c(a), a.forEach((i) => i.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), d("lock unlock", () => {
    x();
  }), d("click", (a, i) => {
    const s = i.target, o = c(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && o && o.length > 0 && !s.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && s === e.navigation.nextEl || e.navigation.prevEl && s === e.navigation.prevEl)) return;
      const A = o[0].classList.contains(e.params.pagination.hiddenClass);
      u(A === !0 ? "paginationShow" : "paginationHide"), o.forEach((O) => O.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const m = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: a
    } = e.pagination;
    a && (a = c(a), a.forEach((i) => i.classList.remove(e.params.pagination.paginationDisabledClass))), r(), k(), x();
  }, f = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: a
    } = e.pagination;
    a && (a = c(a), a.forEach((i) => i.classList.add(e.params.pagination.paginationDisabledClass))), l();
  };
  Object.assign(e.pagination, {
    enable: m,
    disable: f,
    render: k,
    update: x,
    init: r,
    destroy: l
  });
}
function ce(S) {
  let {
    swiper: e,
    extendParams: $,
    on: d
  } = S;
  $({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let u = null, p, E, y = (/* @__PURE__ */ new Date()).getTime();
  function N(t) {
    const n = u;
    n.length !== 0 && (n.innerHTML = "", n.innerHTML = t);
  }
  function D(t) {
    const n = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(t).replace(/x/g, n);
  }
  function L(t) {
    t = c(t), t.forEach((n) => {
      n.setAttribute("tabIndex", "0");
    });
  }
  function b(t) {
    t = c(t), t.forEach((n) => {
      n.setAttribute("tabIndex", "-1");
    });
  }
  function x(t, n) {
    t = c(t), t.forEach((g) => {
      g.setAttribute("role", n);
    });
  }
  function k(t, n) {
    t = c(t), t.forEach((g) => {
      g.setAttribute("aria-roledescription", n);
    });
  }
  function r(t, n) {
    t = c(t), t.forEach((g) => {
      g.setAttribute("aria-controls", n);
    });
  }
  function l(t, n) {
    t = c(t), t.forEach((g) => {
      g.setAttribute("aria-label", n);
    });
  }
  function m(t, n) {
    t = c(t), t.forEach((g) => {
      g.setAttribute("id", n);
    });
  }
  function f(t, n) {
    t = c(t), t.forEach((g) => {
      g.setAttribute("aria-live", n);
    });
  }
  function a(t) {
    t = c(t), t.forEach((n) => {
      n.setAttribute("aria-disabled", !0);
    });
  }
  function i(t) {
    t = c(t), t.forEach((n) => {
      n.setAttribute("aria-disabled", !1);
    });
  }
  function s(t) {
    if (t.keyCode !== 13 && t.keyCode !== 32) return;
    const n = e.params.a11y, g = t.target;
    if (!(e.pagination && e.pagination.el && (g === e.pagination.el || e.pagination.el.contains(t.target)) && !t.target.matches(F(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const B = c(e.navigation.prevEl);
        c(e.navigation.nextEl).includes(g) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? N(n.lastSlideMessage) : N(n.nextSlideMessage)), B.includes(g) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? N(n.firstSlideMessage) : N(n.prevSlideMessage));
      }
      e.pagination && g.matches(F(e.params.pagination.bulletClass)) && g.click();
    }
  }
  function o() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: t,
      prevEl: n
    } = e.navigation;
    n && (e.isBeginning ? (a(n), b(n)) : (i(n), L(n))), t && (e.isEnd ? (a(t), b(t)) : (i(t), L(t)));
  }
  function A() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function O() {
    return A() && e.params.pagination.clickable;
  }
  function G() {
    const t = e.params.a11y;
    A() && e.pagination.bullets.forEach((n) => {
      e.params.pagination.clickable && (L(n), e.params.pagination.renderBullet || (x(n, "button"), l(n, t.paginationBulletMessage.replace(/\{\{index\}\}/, j(n) + 1)))), n.matches(F(e.params.pagination.bulletActiveClass)) ? n.setAttribute("aria-current", "true") : n.removeAttribute("aria-current");
    });
  }
  const v = (t, n, g) => {
    L(t), t.tagName !== "BUTTON" && (x(t, "button"), t.addEventListener("keydown", s)), l(t, g), r(t, n);
  }, I = (t) => {
    E && E !== t.target && !E.contains(t.target) && (p = !0), e.a11y.clicked = !0;
  }, M = () => {
    p = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, R = (t) => {
    y = (/* @__PURE__ */ new Date()).getTime();
  }, h = (t) => {
    if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - y < 100) return;
    const n = t.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!n || !e.slides.includes(n)) return;
    E = n;
    const g = e.slides.indexOf(n) === e.activeIndex, B = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(n);
    g || B || t.sourceCapabilities && t.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
      p || (e.params.loop ? e.slideToLoop(parseInt(n.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(n), 0), p = !1);
    }));
  }, C = () => {
    const t = e.params.a11y;
    t.itemRoleDescriptionMessage && k(e.slides, t.itemRoleDescriptionMessage), t.slideRole && x(e.slides, t.slideRole);
    const n = e.slides.length;
    t.slideLabelMessage && e.slides.forEach((g, B) => {
      const q = e.params.loop ? parseInt(g.getAttribute("data-swiper-slide-index"), 10) : B, H = t.slideLabelMessage.replace(/\{\{index\}\}/, q + 1).replace(/\{\{slidesLength\}\}/, n);
      l(g, H);
    });
  }, w = () => {
    const t = e.params.a11y;
    e.el.append(u);
    const n = e.el;
    t.containerRoleDescriptionMessage && k(n, t.containerRoleDescriptionMessage), t.containerMessage && l(n, t.containerMessage), t.containerRole && x(n, t.containerRole);
    const g = e.wrapperEl, B = t.id || g.getAttribute("id") || `swiper-wrapper-${D(16)}`, q = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    m(g, B), f(g, q), C();
    let {
      nextEl: H,
      prevEl: _
    } = e.navigation ? e.navigation : {};
    H = c(H), _ = c(_), H && H.forEach((U) => v(U, B, t.nextSlideMessage)), _ && _.forEach((U) => v(U, B, t.prevSlideMessage)), O() && c(e.pagination.el).forEach((X) => {
      X.addEventListener("keydown", s);
    }), K().addEventListener("visibilitychange", R), e.el.addEventListener("focus", h, !0), e.el.addEventListener("focus", h, !0), e.el.addEventListener("pointerdown", I, !0), e.el.addEventListener("pointerup", M, !0);
  };
  function z() {
    u && u.remove();
    let {
      nextEl: t,
      prevEl: n
    } = e.navigation ? e.navigation : {};
    t = c(t), n = c(n), t && t.forEach((B) => B.removeEventListener("keydown", s)), n && n.forEach((B) => B.removeEventListener("keydown", s)), O() && c(e.pagination.el).forEach((q) => {
      q.removeEventListener("keydown", s);
    }), K().removeEventListener("visibilitychange", R), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", h, !0), e.el.removeEventListener("pointerdown", I, !0), e.el.removeEventListener("pointerup", M, !0));
  }
  d("beforeInit", () => {
    u = Y("span", e.params.a11y.notificationClass), u.setAttribute("aria-live", "assertive"), u.setAttribute("aria-atomic", "true");
  }), d("afterInit", () => {
    e.params.a11y.enabled && w();
  }), d("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && C();
  }), d("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && o();
  }), d("paginationUpdate", () => {
    e.params.a11y.enabled && G();
  }), d("destroy", () => {
    e.params.a11y.enabled && z();
  });
}
const Le = ({ productName: S, images: e, gtin: $, imageHeight: d, isLoading: u }) => {
  const { t: p } = ee(), [E, y] = V(!1), [N, D] = V(!1), L = W(() => {
    if (!e || !e[$ ?? ""]) return null;
    const { primary: b, additionals: x } = e[$ ?? ""], k = [];
    if (b && k.push(b), x) {
      const r = [...x];
      r.sort((l, m) => {
        const f = parseInt(l.variation), a = parseInt(m.variation);
        return Number.isNaN(f) ? 1 : Number.isNaN(a) ? -1 : f - a;
      }), k.push(...r.filter((l) => l.url !== (b == null ? void 0 : b.url)));
    }
    return k.length > 0 ? k : null;
  }, [e, $]);
  return Z(() => {
    let b;
    return !u && L ? y(!0) : b = setTimeout(() => {
      E || D(!0);
    }, 7e3), () => clearTimeout(b);
  }, [L, u, E]), !E && N ? /* @__PURE__ */ T("div", { className: P.wrapper, style: { height: d + 114 }, children: /* @__PURE__ */ T("div", { className: P.noMediaOrLoading, children: p("not_found") }) }) : E ? /* @__PURE__ */ T("div", { className: P.wrapper, style: { height: d + 114 }, children: /* @__PURE__ */ J(
    ne,
    {
      modules: [re, oe, ce],
      direction: "horizontal",
      centeredSlides: !0,
      navigation: !0,
      pagination: !0,
      className: P.swiper,
      a11y: {
        firstSlideMessage: p("product_carousel_first"),
        prevSlideMessage: p("product_carousel_prev"),
        nextSlideMessage: p("product_carousel_next"),
        lastSlideMessage: p("product_carousel_last")
      },
      children: [
        L == null ? void 0 : L.map((b) => /* @__PURE__ */ T(se, { className: P.slide, children: /* @__PURE__ */ T(
          "img",
          {
            alt: S,
            src: `${b.url}?h=${d + 100}&auto=format&pad=30`,
            className: P.image,
            style: { height: d }
          }
        ) }, b.bynderId)),
        L && L.length > 1 && /* @__PURE__ */ T(le, { size: 48 })
      ]
    }
  ) }) : /* @__PURE__ */ T("div", { className: P.wrapper, style: { height: d + 114 }, children: /* @__PURE__ */ T("div", { className: P.noMediaOrLoading, children: /* @__PURE__ */ T(
    "img",
    {
      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88R8AApUByU2MEcEAAAAASUVORK5CYII=",
      alt: p("loading"),
      className: P.loadingImage,
      width: d,
      height: d
    }
  ) }) });
};
export {
  Le as ProductCardCarousel
};
